<template>
    <div>
        <v-layout row wrap align-center justify-center>
              <v-flex xs12 md7 sm7>
                  <dialogos-app :dialogos="dialogosB" tucan="2"></dialogos-app>
              </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center mt-4>
            <v-flex xs12 sm7 md7 >
                <div class="item-btn-modal btn-blue-light hvr" :class="{'btnexpandvisto':vistosExpand[0]}"  @click="expand = !expand , mostrarContenido(0) , expandB = false">
                    <span>Formais</span>
                    <v-icon color="#0067AD" :class="{'icon-active':expand}">navigate_next</v-icon>
                </div>
                <v-expand-transition>
                <div class="cont-item-modal " v-show="expand">
                    <ul>
                        <li>-Eu sou  Ana Lúcia, </li>
                        <li>muito  prazer!</li>
                        <li>-O prazer é todo meu.</li>
                    </ul>
                </div>
            </v-expand-transition>
            </v-flex>

            <v-flex xs12 sm7 md7 mt-2>
                <div class="item-btn-modal btn-blue-light hvr" :class="{'btnexpandvisto':vistosExpand[1]}"  @click="expandB = !expandB , mostrarContenido(1) , expand = false">
                    <span>Informais</span>
                    <v-icon color="#0067AD" :class="{'icon-active':expandB}">navigate_next</v-icon>
                </div>
               <v-expand-transition>
                <div class="cont-item-modal " v-show="expandB">
                    <ul>
                        <li>-Esta é a minha amiga Mariana.</li>
                        <li>-Oi, Mariana! Prazer!</li>
                        <li>-Prazer!</li>
                    </ul>
                </div>
            </v-expand-transition>
            </v-flex>
        </v-layout>        
    </div>
</template>

<script>
export default {
    data(){
        return {
            dialogosB:[
                'Apresentações.'
            ],
            contVisto:Array(2).fill(false),
            expand:false,
            expandB:false,
            vistosExpand:Array(2).fill(false),
        }
    },
    methods: {
        mostrarContenido(val){
            this.contVisto = Array(2).fill(false)
            this.$set(this.contVisto,val,true)
            this.$set(this.vistosExpand,val,true)
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../../sass/globals';
.item-btn-modal{
    color: #0067AD;
    border-radius: 4px 0px;
    .icon{
    transition: all 0.3s ease-out;
    transform: rotate(0deg);
    }
}
.icon-active{
    transform: rotate(90deg);
}

.cont-item-modal{
    padding: 5px 0px;
    padding: 18px;
    outline: none;
    border:#81C7FD solid;
    border-radius: 0px 4px;
    ul{
        list-style: none;
        text-align: left;
        margin: 0;
        padding: 0;
        li{
            list-style: none;
            margin: 0;
            padding: 0;
        }
    }
}
.cont-visto{
    display: block;
}

</style>